// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__33lyL","tab":"Tabs_tab__dteQ1","tabActive":"Tabs_tabActive__2SujB"};